/** Phase E — ROUTING_EXCEPTION lines: held from every Payout Run, never moved to MSC. */
import React from 'react';
import { money } from '../finance/financeUi';

export function HeldLines({ rows }) {
  if (!rows.length) return <p className="px-5 py-4 text-sm text-muted-foreground" data-testid="held-empty">No routing exceptions for this period.</p>;
  return (
    <ul className="divide-y text-sm" data-testid="held-lines">
      {rows.map((h) => (
        <li key={h.line_id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-2.5" data-testid={`held-line-${h.line_id}`}>
          <span><b>{h.payee_name}</b> <span className="text-xs text-rose-700">{(h.issues || []).join(', ').replace(/_/g, ' ')}</span></span>
          <span className="tabular-nums font-semibold">{money(h.amount)} held</span>
        </li>
      ))}
    </ul>
  );
}
